<template>
  <div class="modal article" :class="{ active: showModal }">
    <div class="container modal-top" @click="$emit('modal', 'article')">
      <div class="modal-top__back-Link">
        <BackIcon />
      </div>
      <div class="modal-top__wrap">
        <div class="modal-top__title">Назад</div>
      </div>
    </div>
    <div class="container article-container" v-cloak>
      <div v-if="article">
        <div class="article__title">{{ article.title }}</div>
        <div class="article__info">
          <div
            class="article__autor"
            @click="
              () => {
                searchByAuthor(article?.author);
              }
            "
          >
            <AuthorAvatar
              v-if="article?.author?.poster_url"
              :src="article.author.poster_url"
            />
            <div v-if="article?.author?.name" class="article__autor_name">
              {{ article.author.name }}
            </div>
          </div>
          <router-link
            v-if="article?.category?.name"
            :to="`/category/${article.category.id}`"
            class="article__category"
            @click="$emit('modal', 'article')"
          >
            {{ article.category.name }}
          </router-link>
        </div>
        <div
          v-if="article.files.length > 0 && showModal"
          class="article__files"
        >
          <div v-if="article.files.length < 2" class="article__file">
            <MediaBlock :media="article.files[0]" :postId="articleId" />
          </div>
          <div v-if="article.files.length > 1" class="article__file">
            <swiper
              :slides-per-view="1"
              :space-between="8"
              @swiper="onSwiper"
              @slideChange="onSlideChange"
            >
              <swiper-slide
                v-for="file in article.files"
                :key="file.id"
                class="article__files_item"
              >
                <MediaBlock :media="file" :postId="articleId" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <TextWithLinks
          class="article__text"
          :text="article.description"
          @openArticle="(id) => $emit('openArticle', id)"
        ></TextWithLinks>
        <div
          class="article__likes"
          :class="{ active: article.is_liked_by_auth_user }"
        >
          <div
            class="article__likes_icon"
            @click="doLike(article.is_liked_by_auth_user ? false : true)"
          >
            <HeartIcon />
          </div>
          <div class="article__likes_count">{{ article.likes_count }}</div>
        </div>
        <div class="articles-more" v-cloak>
          <div class="articles-more__title">
            {{ articles_more_text || 'Вам может быть интересно' }}
          </div>
          <div class="articles-more__wrap">
            <div
              v-for="article in articles_more"
              :key="article.id"
              class="articles-more__item"
              @click="$emit('openArticle', article.id)"
            >
              <div class="articles-more__image">
                <img
                  v-if="article?.poster_url"
                  :src="article.poster_url"
                  :alt="article.title"
                />
              </div>
              <div class="articles-more__info">
                <div
                  class="articles-more__description"
                  v-html="parseText(article.description)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthorAvatar from '@/components/blocks/author/AuthorAvatar.vue';
import BackIcon from '@/components/icons/BackIcon.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import HeartIcon from '@/components/icons/HeartIcon.vue';
import { getArticle, like, unlike } from '@/functions/API';
import MediaBlock from '@/components/blocks/media/MediaBlock.vue';
import TextWithLinks from '@/components/blocks/link/TextWithLinks.vue';

export default {
  name: 'ArticleModal',
  components: {
    AuthorAvatar,
    BackIcon,
    Swiper,
    SwiperSlide,
    HeartIcon,
    MediaBlock,
    TextWithLinks,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    articleId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      article: null,
      showModal: false,
      articles_more: [],
      articles_more_text: '',
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  mounted() {
    this.showModal = this.show;
  },
  watch: {
    show() {
      this.showModal = this.show;
      if (this.show && this.articleId) {
        this.getPage(this.articleId);
      }
      if (this.show) {
        this.$nextTick(() => {
          const container = this.$el.querySelector('.article-container');
          if (container) container.scrollTop = 0;
        });
      }
    },
    articleId() {
      this.showModal = this.show;
      if (this.show && this.articleId) {
        this.getPage(this.articleId);
      }
    },
  },
  methods: {
    getPage(id) {
      getArticle(id, (res) => {
        if (res !== false) {
          this.article = res.data ?? null;
          this.articles_more = res.similar_materials ?? [];
          this.articles_more_text = res.similar_materials_message ?? '';
        }
        this.$nextTick(() => {
          const container = this.$el.querySelector('.article-container');
          if (container) container.scrollTo({ top: 0, behavior: 'smooth' });
        });
      });
    },
    doLike(target) {
      if (target) {
        like(this.articleId, (res) => {
          if (res !== false) {
            this.getPage(this.articleId);
          }
        });
      } else {
        unlike(this.articleId, (res) => {
          if (res !== false) {
            this.getPage(this.articleId);
          }
        });
      }
    },
    searchByAuthor(author) {
      this.$emit('modal', 'article');
      this.$router.push({
        name: 'lib',
        query: { author_name: author.name, author_id: author.id },
      });
    },
    parseText(text) {
      const regex = /\[(https?:\/\/[^\]|]+|id=\d+)\|([^\]]+)\]/g;
      return text.replace(regex, (match, url, linkText) => {
        return linkText;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  width: 100%;
  height: 100vh;
  &-top {
    position: relative;
    background-color: var(--color-white);
    color: var(--color-black);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    position: relative;
    display: flex;
    padding-top: 16px;
    padding-bottom: 16px;
    cursor: pointer;
    &__wrap {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      min-height: 40px;
    }
    &__back-Link {
      color: var(--color-blue);
      svg {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
      }
    }
    &__title {
      color: var(--color-black);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
  }
}
.article {
  position: fixed;
  left: 0;
  top: -120%;
  height: 100%;
  width: 100%;
  background-color: var(--color-white);
  transition: 0.3s ease-in-out;
  &.active {
    top: 0;
  }
  &-container {
    display: flex;
    flex-direction: column;
    gap: 32px;
    overflow-y: auto;
    max-height: calc(100vh - 72px);
    height: 100%;
  }
  &__title {
    color: var(--color-black);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  &__autor {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    &_name {
      color: var(--color-gray);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%;
    }
  }
  &__category {
    color: var(--color-gray);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
    background-color: var(--color-gray-light);
    border-radius: 30px;
    padding: 6px 10px;
    text-align: center;
  }
  &__files {
    overflow: hidden;
    .swiper {
      overflow: visible;
      max-width: 80%;
      margin-left: 0;
    }
  }
  &__file {
    width: 100%;
    height: 220px;
    position: relative;
  }
  &__text {
    color: var(--color-black);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin-top: 32px;
    margin-bottom: 32px;
  }
  &__likes {
    display: flex;
    align-items: center;
    gap: 6px;
    &_icon {
      width: 34px;
      height: 34px;
      background-color: var(--color-gray-light);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: var(--color-blue);
      svg {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
      }
    }
    &_count {
      color: var(--color-gray);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%;
    }
    &.active {
      .article__likes_icon {
        background-color: var(--color-blue);
        color: var(--color-white);
      }
      .article__likes_count {
        color: var(--color-blue);
      }
    }
  }
}
.articles-more {
  margin-top: 32px;
  margin-bottom: 16px;

  &__title {
    color: var(--color-black);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  p {
    margin-bottom: 6px;
  }
  &__wrap {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
    margin-bottom: 60px;
  }
  &__item {
    width: 100%;
    overflow: hidden;
    position: relative;
    border-radius: 12px;
    cursor: pointer;
  }
  &__image {
    width: 100%;
    height: calc((100vw - 32px) / 16 * 9);
    max-height: 315px;
    z-index: 0;
    display: flex;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 14px;
      background-color: var(--color-gray);
    }
  }
  &__info {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 16px;
    background-color: var(--color-white-opacity);
    z-index: 1;
  }
  &__description {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    color: var(--color-black);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
